"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBHelp = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var MBText_1 = require("../MBText");
var MBTooltip_1 = require("../MBTooltip");
var MBIconButton_1 = require("../MBIconButton");
var MBButton_1 = require("../MBButton");
var InfoIcon_1 = require("../Icons/InfoIcon");
var themes_1 = require("../../themes");
var MBHelp = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, title = _a.title, description = _a.description, href = _a.href, _c = _a.hrefTitle, hrefTitle = _c === void 0 ? 'common:buttons.learn-more' : _c, _d = _a.maxWidth, maxWidth = _d === void 0 ? 310 : _d, _e = _a.placement, placement = _e === void 0 ? 'top-start' : _e;
    var externalURL = href;
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx(MBTooltip_1.MBTooltipComic, __assign({ bgcolor: themes_1.THEME.colors.basic.White100, color: themes_1.THEME.colors.basic.Black, arrow: true, placement: placement, interactive: true, maxWidth: maxWidth, title: jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [title && jsx_runtime_1.jsx(MBText_1.MBText, { variant: "h4", t: title }, void 0),
                    description && (jsx_runtime_1.jsx(core_1.Box, __assign({ mt: 0.5 }, { children: jsx_runtime_1.jsx(MBText_1.MBText, { variant: "body2", t: description }, void 0) }), void 0)),
                    href && (jsx_runtime_1.jsx(StyledLink, __assign({ target: "_blank", rel: "noopener noreferrer", href: externalURL }, { children: jsx_runtime_1.jsxs(MBButton_1.MBButton, __assign({ border: "none", hoverVariant: MBButton_1.IMBButtonHoverVariant.darken, mt: 1, padding: "0" }, { children: [jsx_runtime_1.jsx(MBText_1.MBText, { color: "#5059C9", t: hrefTitle, mr: 0.5, variant: "h5" }, void 0),
                                jsx_runtime_1.jsx(MBText_1.MBText, { color: "#5059C9", t: "\u2192", variant: "h5" }, void 0)] }), void 0) }), void 0))] }, void 0) }, { children: jsx_runtime_1.jsx("div", { children: jsx_runtime_1.jsx(MBIconButton_1.MBIconButton, { Icon: { component: InfoIcon_1.InfoIcon, props: { size: size } } }, void 0) }, void 0) }), void 0) }, void 0));
};
exports.MBHelp = MBHelp;
var StyledLink = styled_components_1.default('a')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "\n  text-decoration: none;\n\n  cursor: pointer;\n\n  ", "\n"], ["\n  width: ",
    "\n  text-decoration: none;\n\n  cursor: pointer;\n\n  ",
    "\n"])), function (_a) {
    var width = _a.width;
    return width
        ? typeof width === 'string'
            ? "width: " + width + ";"
            : "width: " + width + "px;"
        : '100%;';
}, function (_a) {
    var variant = _a.variant;
    switch (variant) {
        case 'classic':
            return "\n  color: #2b6be9;\n  font-weight: bold;\n  ";
        case 'black':
            return "\n  color: #000;\n  font-weight: bold;\n  ";
        case 'meetbutter':
            return "\n        \n    \n    color: #2F80ED\n    ";
        default:
            return "\n        color: inherit;\n      ";
    }
});
var templateObject_1;
//# sourceMappingURL=MBHelp.js.map